export enum PictureFrameStyle {
    CircleFit = 0,
    CircleCover = 1,
    Original = 2,
    Fit = 3,
    Cover = 4,
    RoundedFit = 5,
    RoundedCover = 6,
}